'use strict';

module.exports = '3.27.0';



//////////////////
// WEBPACK FOOTER
// ../node_modules/algoliasearch/src/version.js
// module id = 975
// module chunks = 20 21 22 23 24 25 26 27 28